import _common from "./modules/common";
import _matchHeight from "./modules/match_height";
import _header from "./modules/header";
import _footer from "./modules/footer";
import _kvSlider from "./modules/kv_slider";
import _insertBg from "./modules/insert_bg";
import _tab from "./modules/tab";
import _print from "./modules/print";
import _form from "./modules/form";
import _popup from "./modules/popup";
import _anchor from "./modules/anchor";

//common
const common = new _common();
const media = common.getEnvironment().media;
common.init();

//matchHeight
const matchHeight = new _matchHeight();
$(window).on('load',function(){
  matchHeight.init();
});

//header
const header = new _header({
  media: media
});
header.init();

//footer
const footer = new _footer();
footer.init();

//kvSlider
const kvSlider = new _kvSlider({
  media: media
});
kvSlider.init();

//insertBg
const insertBg = new _insertBg();
insertBg.init();

//tab
const tab = new _tab();
$(document).on('click', '.c-tab_card', function(event) {
  event.preventDefault();
  tab.tabCard(common.getEnvironment().media, $(this));
});

//print
const print = new _print();
$(document).on('click', '.js-print', function(event) {
  event.preventDefault();
  print.init();
});

//form
const form = new _form();
form.init();

//popup
const popup = new _popup();
popup.init();

//popup
const anchor = new _anchor({
  media: media
});
anchor.init();




// WEBPACK FOOTER //
// ./src/assets/js/script.js